import styled from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const DashboardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const DashboardTitle = styled.h1`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.dark};
  letter-spacing: -0.02em;
`;

export const DurationControl = styled.div`
  width: 13rem;
  min-width: 13rem;
  flex-shrink: 0;

  & > div {
    width: 100%;
    min-width: 100%;
  }
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2.5rem 2.5rem;

  ${media.md} {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const ChartCard = styled.article`
  display: flex;
  flex-direction: column;
  min-height: 20.5rem;
  padding: 1rem 1.5rem 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  background: ${({ theme }) => theme.background};
  box-shadow:
    0 2px 4px rgba(57, 57, 57, 0.04),
    0 8px 16px rgba(57, 57, 57, 0.04);
`;

export const ChartCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-bottom: 0.5rem;
`;

export const ChartCardTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.dark};
`;

export const ChartCardDuration = styled.span`
  display: inline-flex;
  align-items: center;
  height: 2.5rem;
  padding: 0 0.85rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.dark};
  background: ${({ theme }) => theme.background};
  white-space: nowrap;
`;

export const ChartMainValue = styled.p`
  margin: 0;
  font-size: 2rem;
  font-weight: 400;
  letter-spacing: -0.075em;
  color: ${({ theme }) => theme.dark};
  line-height: 1.2;
`;

export const ChartSubValue = styled.p`
  margin: 0 0 1rem;
  font-size: 1rem;
  color: ${({ theme }) => theme.dark};
  min-height: 1.25rem;
`;

export const ChartBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 9rem;
`;

export const ChartCanvas = styled.div`
  flex: 1;
  min-height: 7.5rem;
  width: 100%;
  overflow: visible;

  svg {
    overflow: visible;
  }
`;

export const ChartLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding-top: 1.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: ${({ theme }) => theme.dark};
`;

export const LegendDot = styled.span`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.primary};
`;

export const ChartEmpty = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.midGrey};
  font-size: 0.875rem;
`;

export const ChartError = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.danger || '#c0392b'};
  font-size: 0.875rem;
  text-align: center;
  padding: 1rem;
`;

/* Legacy exports kept for unused Dashboard subcomponents */
export const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  grid-gap: 1vw;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledWidgetHighlightedWrap = styled.div`
  display: flex;
  margin-bottom: 2vh;

  @media only screen and (max-width: 1024px) {
    display: block;

    & > div:nth-child(1) {
      width: calc(100% - 12%);
      padding: 4% 6%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    & > div:nth-child(2) {
      margin: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;

export const StyledWrap = styled.div`
  width: -webkit-fill-available;

  ul {
    padding-left: 0;
  }

  & > div:nth-child(1) {
    margin-bottom: 0.75rem;
  }
`;

export const StyledWidgetsWrap = styled.div`
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 4vh;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledSVGWrap = styled.div`
  flex-grow: 1;
  justify-content: center;
  display: flex;
`;
